import { render, staticRenderFns } from "./DarkModeSwitch.vue?vue&type=template&id=55400b21&"
import script from "./DarkModeSwitch.vue?vue&type=script&lang=ts&"
export * from "./DarkModeSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports